﻿<script>
	import { tick } from "svelte";

	export let id;
	export let label;
	export let htmlLabel = null;
	export let value;
	export let maxlength = null;
	export let minlength = null;
	export let disabled = null;
	export let readonly = null;
	export let required = null;
	export let max = null;
	export let min = 0;

	const KEYBOARD = {
		BACKSPACE: 8,
		DELETE: 46
	};

	const handleKeyDown = (e) => {
		// Prevent the following from being entered on desktop
		if (e.key === "e" || e.key === "E" || e.key === ".") {
			e.preventDefault();
		}
	};

	const handlePaste = async (e) => {
		var pastedDigits = e.clipboardData.getData("text").replace(/\D/g, "");
		var start = e.target.selectionStart;
		var end = e.target.selectionEnd;

		var resultingValue = value ? value.substring(0, start) + pastedDigits + value.substring(end) : pastedDigits;

		if (maxlength) resultingValue = resultingValue ? resultingValue.substring(0, maxlength) : "";
		value = resultingValue;

		await tick();
		e.target.setSelectionRange(start, end);

		e.preventDefault();
		return false;
	};

	const validateInput = (event) => {
		const input = event.target;

		// Occurs on Android Chrome as keyDown is stuffed for INPUT type=number and gives e.key=Unidentified
		if (event.data == ".") {
			input.value = input.value.replace(/\./g, "");

			// Chrome doesn't move the cursor properly when the value is changed.
			// setSelectionRange on chrome has strange behavior for input type=number.
			input.setSelectionRange(input.value.length, input.value.length);
		}
	};
</script>

{#if label}
	<label for={id} class:isrequired={required}>{label}</label>
{:else if htmlLabel}
	<label for={id} class:isrequired={required}>{@html htmlLabel}</label>
{/if}
<input
	{required}
	{disabled}
	{readonly}
	{maxlength}
	{minlength}
	{max}
	{min}
	type="number"
	bind:value
	{id}
	class="form-control"
	on:keydown={handleKeyDown}
	on:input={validateInput}
	on:paste={handlePaste}
/>
